// extracted by mini-css-extract-plugin
export default {"yAxisTitle":"styles_yAxisTitle__VpbaO"};